<template>
  <ul :style="showLoadingState < 4 ? `opacity: 0.5` : `opacity: 1`">
    <li
      v-for="(itemAside, index) in itemsAsideMenu"
      :key="index"
    >
      <router-link
        v-if="itemAside.to"
        :class="itemAside.class"
        :to="showLoadingState < 4 ? '' : itemAside.to"
      >
        <span class="m-item-aside-icon">
          <i :class="itemAside.icon"></i>
        </span>
        <span>{{ itemAside.text }}</span>
        <span
          v-if="itemAside.required"
          class="m-item-aside-icon-required"
        >
          <i class="fas fa-circle"></i>
        </span>
      </router-link>
      <a
        v-else
        href="#"
        :class="itemAside.class"
        @click.prevent="emitAction(itemAside)"
      >
        <span class="m-item-aside-icon">
          <i :class="itemAside.icon"></i>
        </span>
        <span>{{ itemAside.text }}</span>
        <span
          v-if="itemAside.required"
          class="m-item-aside-icon-required"
        >
          <i class="fas fa-circle"></i>
        </span>
      </a>

    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomEditionSectionNavigationMenu',

  props: {
    itemsAsideMenu: Array,
    showLoadingState: Number
  },

  methods: {
    emitAction (itemAside) {
      this.$emit(itemAside.method, itemAside.params)
    }
  }
}
</script>
